"use client";

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useBannerAdOpen } from '@wt/game/providers/bannerAdOpen/BannerAdOpenProvider';
import { getFeedbackLink } from '@wt/utilities/feedbackLink';
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useMemo } from 'react';

export default function PrivacyPolicyContent() {
  const router = useRouter();
  const { adOpen } = useBannerAdOpen();

  const top = useMemo(() => {
    return adOpen ? 'top-[100px] md:top-[112px] lg:top-[164px]' : 'top-[54px] md:top-[78px]';
  },[adOpen]);

  return (
    <div className="flex w-full flex-1 grow flex-col items-center px-4 md:px-8">
      <div className="flex max-w-4xl flex-col space-y-6 rounded-3xl text-sm md:my-6 md:bg-base-200 md:px-6 md:pb-6">
        <div
          className={`sticky ${top} z-20 flex w-full flex-row items-center justify-between bg-base-100 py-6 md:bg-base-200`}
        >
          <div onClick={() => router.back()}>
            <ChevronLeftRoundedIcon className="m-0 fill-current text-2xl leading-none hover:cursor-pointer" />
          </div>
          <div className="mx-20 grow text-center">
            <span className="text-lg font-medium lg:text-4xl">
              Privacy Policy
            </span>
          </div>
          <Link href={'/game'} className="hidden md:flex">
            <CloseRoundedIcon className="m-0 fill-current text-2xl leading-none" />
          </Link>
        </div>

        <p>
          Your privacy is important to us. To better protect your sensitive
          information, we provide this notice explaining our online information
          practices and how they relate specifically in regard of what type or
          quantity data might be collected from you by way of using the website
          at any given time during browsing sessions on either desktop
          computers, tablets, or mobile devices.
        </p>

        <p className="text-lg font-bold">Our Commitment</p>
        <p>
          We do not collect any personal information on this site. Third party
          vendors may use cookies to serve ads based on a user’s prior visits to
          your website or other websites. Google’s use of advertising cookies
          enables it and its partners to serve ads to your users based on their
          visit to your sites and/or other sites on the Internet. Users may opt
          out of personalized advertising.
        </p>

        <p className="text-lg font-bold">Information We Collect</p>
        <p>
          We collect the IP address and click patterns of our users for a
          period, but this data is never sold or shared with anyone else. We use
          it to see how people interact online so that we can make improvements
          on what they experience in their user interface (UI). Our email
          addresses are kept only as long as necessary; when responding back
          from customer inquiries or feedback–we do not reuse those same
          respondents’ names again next time around!
        </p>

        <p className="text-lg font-bold">Third Party Services</p>
        <p>
          We collect generic website analytics by way of website browser and
          cookies. Our analytics data collected is anonymous. We may work with
          third-party advertising companies to deliver ads when you visit our
          site. These firms may use aggregated information about your internet
          activity and other websites that are visited in order provide
          advertisements relevant for you on this platform only, but not
          including any personal details such as name or address.
        </p>

        <p>
          We use a third-party to provide monetization technologies for our
          site. You can review their privacy and cookie policy{' '}
          <a
            target="_blank"
            href="https://www.snigel.com/privacy-policy/"
            className="underline"
          >
            here
          </a>
          .
        </p>

        <p>
          You can change your privacy settings by clicking the following button:{' '}
          <button onClick={() => "adconsent('showGUI')"} className="underline">
            Manage Consent
          </button>
        </p>

        <p className="text-lg font-bold">
          California Consumer Privacy Act (CCPA)
        </p>
        <p>Manage your consent by way of the CCPA</p>

        <p className="text-lg font-bold">Log Data</p>
        <p>
          We collect certain log data whenever you access our website or
          services. The information we collect may include your IP address,
          device name and version as well as the time you utilize our service.
          We use these and other statistics to help us provide improvements to
          the website.
        </p>

        <p className="text-lg font-bold">Cookies</p>
        <p>
          Cookies are files with a small amount of data that are commonly used
          as anonymous unique identifiers. These are sent to your browser from
          the websites that you visit and are stored on your device’s internal
          memory.
        </p>

        <p>
          This Service does not use these “cookies” explicitly. However, the
          app/website may use third party code and libraries that use “cookies”
          to collect information and improve their services. You have the option
          to either accept or refuse these cookies and know when a cookie is
          being sent to your device. If you choose to refuse our cookies, you
          may not be able to use some portions of this Service.
        </p>

        <p className="text-lg font-bold">Contact</p>
        <p>
          We would love to hear from you! Whether you have a concern or simply
          want to say hello, please{' '}
          <a target="_blank" href={getFeedbackLink()} className="underline">
            get in touch with us
          </a>
          .
        </p>

        <p className="text-lg font-bold">Delete Account</p>
        <p>
          If you have an account and would like to delete it, please{' '}
          <a target="_blank" href={getFeedbackLink()} className="underline">
            contact us
          </a>
          .
        </p>
      </div>
    </div>
  );
}
